import { LoginSection, LoginSectionProps } from './LoginSection';
import { useClientLogin } from './useClientLogin';

export function LoginSectionWrapper(props: Pick<LoginSectionProps, 'className' | 'instructionClassName'>) {
  const { handleLogin, isAuthenticated } = useClientLogin();

  return <LoginSection isAuthenticated={isAuthenticated} onLogin={handleLogin} {...props} />;
}
